export enum FreelancerOnboardingStatus {
	NotSubmitted = 0,
	Submitted = 1,
	Interview = 2,
	SoftSkillsEvaluation = 3,
	HardSkillsEvaluation = 4,
	Positioning = 5,
	Accepted = 6,
	Refused = 7
}
